
(function () {
  'use strict';

  angular
    .module('app.treviews', [])

    /* @ngInject */
    .service('TReviewsService', ["$http", function ($http) {
      this.get = function (id, page, nbPerPage, sort, filter) {
        return $http({
          method: 'GET',
          url: 'Reviews/' + id + '/' + page + '/' + nbPerPage + '/' + sort + '/' + filter
        }).then(function (response) {
          console.log(response);
          return response.data;
        }).catch(function (error) {
          console.error(error);
        });

      };
    }])

    /* @ngInject */
    .directive('tReviews', function () {
      return {
        restrict: 'A',
        bindToController: {
          idProduct: '='
        },
        controllerAs: 'trevCtrl',
        /* @ngInject */
        controller: ["TReviewsService", function (TReviewsService) {
          var ctrl = this;

          ctrl.currentPage = 1;
          ctrl.nbPerPage = 5;
          var currentSort = 'rateDESC';

          ctrl.$onInit = function () {
            update();
          };

          ctrl.pageChanged = function () {
            update();
          };

          ctrl.setSort = function (sort) {
            currentSort = sort;
            ctrl.currentPage = 1;
            update();
          };

          function update() {
            TReviewsService.get(ctrl.idProduct, ctrl.currentPage, ctrl.nbPerPage, currentSort, 0)
              .then(function (data) {
                ctrl.listReviews = data;
                ctrl.active = true;
              });
          }
        }]
      };
    })

    /* @ngInject */
    .directive('lastReview', function () {

      return {
        restrict: 'A',
        bindToController: {
          idProduct: '='
        },
        controllerAs: 'lastCtrl',

        /* @ngInject */
        controller: ["TReviewsService", function (TReviewsService) {
          var ctrl = this;


          ctrl.$onInit = function () {

            TReviewsService.get(ctrl.idProduct, 1, 1, 'dateDESC', 0)
              .then(function (data) {
                ctrl.Comment = data.Reviews.CurrentPageReviews[0].Comment;
              });

          };
        }]
      };
    });
})();
